<template>
  <div class="widget-not-allowed">
    <div class="widget-image">
      <b-icon style="font-size: 130px" icon="block-helper" size="is-large" />
    </div>
    <div class="widget-title">{{ title }}</div>
    <div class="widget-subtitle">
      {{ subtitle }}
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "widget-not-allowed",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
  <style lang="scss" scoped>
.widget-not-allowed {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 40px;
  .widget-image {
    margin-bottom: 40px;
  }
  .widget-title {
    text-align: center;
    font-size: 30px;
  }
  .widget-subtitle {
    text-align: center;
  }
}
</style>
<style lang="scss">
.widget-not-allowed {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 40px;
  .widget-image {
    .mdi-48px.mdi:before {
      font-size: 170px !important;
      color: #5a0718;
    }
  }
}
</style>
  